export const BRIEF_FIELD_LABELS = [
	{ key: "job", label: "What it does" },
	{ key: "whoActs", label: "Who acts on it" },
	{ key: "produces", label: "What it produces" },
	{ key: "requestInput", label: "What you ask it when running it" },
	{ key: "looksAt", label: "What it reads" },
	{ key: "findings", label: "What counts as a finding" },
	{ key: "evidence", label: "Evidence it gives" },
	{ key: "nextSteps", label: "Next steps it suggests" },
	{ key: "scope", label: "Which clients and period" },
	{ key: "exclusions", label: "What it ignores" },
	{ key: "name", label: "Name" },
	{ key: "description", label: "One-line description" },
];

export const PREVIEW_PARTS = [
	{ key: "head", label: "Name and one-line description", fieldKeys: ["name", "description"], emptyText: "The guide names it once the job is clear." },
	{ key: "does", label: "What it does", fieldKeys: ["job"], emptyText: "The guide fills this in as you describe the job." },
	{ key: "reads", label: "What it reads", fieldKeys: ["looksAt", "requestInput"], unlabelledFieldKeys: ["looksAt"], emptyText: "The records, sources and documents it reads show here." },
	{ key: "looksFor", label: "What it looks for", fieldKeys: ["findings", "evidence"], emptyText: "What counts as a finding, and the evidence it gives, show here." },
	{ key: "produces", label: "What it produces", fieldKeys: ["produces", "nextSteps"], unlabelledFieldKeys: ["produces"], emptyText: "What it produces and the next steps it suggests show here." },
	{ key: "whoActs", label: "Who acts on it", fieldKeys: ["whoActs"], emptyText: "Who acts on what it finds shows here." },
	{ key: "clients", label: "Which clients and when", fieldKeys: ["scope", "exclusions"], emptyText: "Which clients and period it covers, and what it ignores, show here." },
	{ key: "skills", label: "Skills and tools", fieldKeys: [], emptyText: "Skills and tools from the firm's library show here as the job becomes clear." },
];

export const SKILL_BRIEF_FIELD_LABELS = [
	{ key: "purpose", label: "What it lets an agent do" },
	{ key: "whenUsed", label: "When it is used" },
	{ key: "inputs", label: "What it needs in hand" },
	{ key: "steps", label: "The steps" },
	{ key: "checks", label: "What makes the result right" },
	{ key: "evidence", label: "Evidence it records" },
	{ key: "whenMissing", label: "When something is missing" },
	{ key: "tools", label: "Tools it uses" },
	{ key: "name", label: "Name" },
	{ key: "description", label: "One-line description" },
];
